/** Bounded receipt history survives WebView reloads; stores only opaque event IDs. */
const MAX_RECEIPTS = 500;
const RECEIPT_TTL_MS = 24 * 60 * 60 * 1000;
const STORAGE_KEY = "hiive:push-receipts:v1";
export class PushReplayGuard {
  private receipts = new Map<string, number>();
  constructor(private storage?: Pick<Storage, "getItem" | "setItem">) {
    try {
      const saved: unknown = JSON.parse(storage?.getItem(STORAGE_KEY) ?? "[]");
      if (Array.isArray(saved))
        for (const item of saved) {
          if (
            Array.isArray(item) &&
            typeof item[0] === "string" &&
            typeof item[1] === "number"
          )
            this.receipts.set(item[0], item[1]);
        }
    } catch {
      /* Receipt persistence is best effort. */
    }
    this.prune();
  }
  private prune() {
    for (const [key, timestamp] of this.receipts)
      if (timestamp <= Date.now() - RECEIPT_TTL_MS) this.receipts.delete(key);
    while (this.receipts.size > MAX_RECEIPTS) {
      const first = this.receipts.keys().next().value;
      if (first === undefined) break;
      this.receipts.delete(first);
    }
  }
  private save() {
    this.prune();
    try {
      this.storage?.setItem(STORAGE_KEY, JSON.stringify([...this.receipts]));
    } catch {
      /* Private browsing/full storage. */
    }
  }
  claim(eventId: string) {
    this.prune();
    if (this.receipts.has(eventId)) return false;
    this.receipts.set(eventId, Date.now());
    this.save();
    return true;
  }
  release(eventId: string) {
    this.receipts.delete(eventId);
    this.save();
  }
}

export function foregroundNotificationId(eventId: string): number {
  let value = 2166136261;
  for (let index = 0; index < eventId.length; index++)
    value = Math.imul(value ^ eventId.charCodeAt(index), 16777619);
  return ((value >>> 0) % 2_147_483_646) + 1;
}
